import { render, staticRenderFns } from "./LoveCard.vue?vue&type=template&id=6ca01e8c&"
import script from "./LoveCard.vue?vue&type=script&lang=js&"
export * from "./LoveCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports